"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnippetType = exports.SnippetComputeDirection = void 0;
var SnippetComputeDirection;
(function (SnippetComputeDirection) {
    SnippetComputeDirection["higher"] = "higher";
    SnippetComputeDirection["lower"] = "lower";
})(SnippetComputeDirection = exports.SnippetComputeDirection || (exports.SnippetComputeDirection = {}));
var SnippetType;
(function (SnippetType) {
    SnippetType["connectionComparison"] = "connectionComparison";
    SnippetType["allUserComparison"] = "allUserComparison";
    SnippetType["similarityComparison"] = "similarityComparison";
    SnippetType["aggregatePeerTwoByTwo"] = "aggregatePeerTwoByTwo";
    SnippetType["peerRatedNature"] = "peerRatedNature";
    SnippetType["topPeerRatedTraits"] = "topPeerRatedTraits";
    SnippetType["peerRatedTraitsDelta"] = "peerRatedTraitsDelta";
    SnippetType["aggregatePeerSpectrum"] = "aggregatePeerSpectrum";
    SnippetType["llmList"] = "llmList";
    SnippetType["llmTitlesAndContent"] = "llmTitlesAndContent";
    SnippetType["llmMatch"] = "llmMatch";
    SnippetType["llmHeaderedList"] = "llmHeaderedList";
    SnippetType["llmHeaderAndBody"] = "llmHeaderAndBody";
    SnippetType["llmNatureStatements"] = "llmNatureStatements";
    SnippetType["llmOrderedMatch"] = "llmOrderedMatch";
    SnippetType["llmUnorderedMatch"] = "llmUnorderedMatch";
    SnippetType["topScoringTraits"] = "topScoringTraits";
    SnippetType["nutshell"] = "nutshell";
})(SnippetType = exports.SnippetType || (exports.SnippetType = {}));
